import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import api from '../lib/api';

export default function ChangePasswordPage() {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (newPassword.length < 4) {
            setError('비밀번호는 4자 이상이어야 합니다');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('비밀번호가 일치하지 않습니다');
            return;
        }

        setLoading(true);
        try {
            const { data } = await api.post('/auth/change-password', { newPassword });
            sessionStorage.setItem('token', data.token);
            sessionStorage.setItem('user', JSON.stringify(data.user));
            navigate('/');
        } catch (err: any) {
            setError(err.response?.data?.error || '비밀번호 변경에 실패했습니다');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F7F7F7] flex items-center justify-center">
            <div className="w-full max-w-sm">
                <div className="bg-white rounded-lg shadow-lg border border-[#E6E9ED] p-8">
                    <div className="flex items-center justify-center gap-2 mb-4">
                        <Building2 className="w-6 h-6 text-[#1ABB9C]" />
                        <h1 className="text-lg font-bold text-[#2A3F54]">비밀번호 변경</h1>
                    </div>
                    <p className="text-xs text-[#73879C] text-center mb-6">
                        최초 로그인입니다. 새 비밀번호를 설정해주세요.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-medium text-[#73879C] mb-1">새 비밀번호</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="w-full px-3 py-2.5 text-sm border border-[#E6E9ED] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ABB9C]/20 focus:border-[#1ABB9C]"
                                placeholder="4자 이상"
                                autoFocus
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-[#73879C] mb-1">비밀번호 확인</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full px-3 py-2.5 text-sm border border-[#E6E9ED] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ABB9C]/20 focus:border-[#1ABB9C]"
                                placeholder="비밀번호 재입력"
                            />
                        </div>

                        {error && (
                            <div className="text-xs text-red-500 bg-red-50 px-3 py-2 rounded">{error}</div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-2.5 text-sm font-medium bg-[#1ABB9C] text-white rounded-lg hover:bg-[#169F85] transition disabled:opacity-50"
                        >
                            {loading ? '변경 중...' : '비밀번호 변경'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
